import React from 'react';
import { Nav, NavItem, NavLink, Row } from "reactstrap";
import classnames from 'classnames';
import styles from './styles.css';
import PropTypes from 'prop-types';
import { Carousel } from '../carousel';
import { reStyleCategory } from '../../config';

class _CategoriesTabs extends React.Component {

    constructor(props) {
        super(props);
        this.setActiveTab = this.setActiveTab.bind(this);

        this.state = {
            categories: []
        };
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
    }

    setActiveTab(category) {
        // console.log('setActiveTab');
        if (this.state.activeTab !== category.name) {
            // if (this.state.timeDiff < 500 && this.state.activeTab !== category.name) {
            this.setState({
                activeTab: category.name
            });
            this.props.selectedRegions(category);
        };
    };

    render() {
        const categories = this.props.categories || [];
        return (
            <div className={styles.carouselWrap}>
                <Nav className={styles.nav}
                    // style={{ left: `${this.props.transX}px` }}
                    style={{ transform: `translate(${this.props.transX}px, 0px)` }}
                    onTouchMove={this.props.onTouchMove}
                    onTouchEnd={this.props.onTouchEnd}
                    onMouseMove={this.props.onMouseMove}
                    onMouseUp={this.props.onMouseUp}
                    onMouseLeave={this.props.onMouseLeave}
                    onDragStart={this.props.onDragStart}
                    onTouchStart={this.props.onTouchStart}
                    onMouseDown={this.props.onMouseDown}>
                    {
                        categories.map((category, i) =>
                            <NavItem key={i}
                                className={styles.item}
                                onClick={() => { this.setActiveTab(category) }}>
                                <NavLink>
                                    {category.name}
                                    <div className={classnames(
                                        styles.bar,
                                        i == 0 && !this.state.activeTab || this.state.activeTab === category.name ? styles.active : '')}>
                                    </div>
                                </NavLink>
                            </NavItem>
                        )
                    }
                </Nav>
            </div>
        )
    };
};

_CategoriesTabs.propTypes = {
    transX: PropTypes.number,
    onTouchMove: PropTypes.func,
    onTouchEnd: PropTypes.func,
    onMouseMove: PropTypes.func,
    onMouseUp: PropTypes.func,
    onMouseLeave: PropTypes.func,
    onDragStart: PropTypes.func,
    onTouchStart: PropTypes.func,
    onMouseDown: PropTypes.func
}

class _CategoriesTabs2 extends React.Component {

    constructor(props) {
        super(props);

        this.setActiveTab = this.setActiveTab.bind(this);

        this.state = {
            categories: [],
            activeTab: props.activeTab
        };
    };

    setActiveTab(category) {
        if (this.state.activeTab !== reStyleCategory && category.name === reStyleCategory) {
            this.props.showConfirmationOverlay('makeup-to-hair', category.name)
            return;
        }

        if (this.state.activeTab === reStyleCategory && category.name !== reStyleCategory) {
            this.props.showConfirmationOverlay('hair-to-makeup', category.name)
            return;
        }

        if (this.state.activeTab !== category.name) {
            this.setState({
                activeTab: category.name
            });
            this.props.selectedRegions(category);
        };
    };

    render() {
        const categories = this.props.categories || [];
        return (
            <div className={styles.carouselWrap}>
                <div className={styles.nav}>
                    <Carousel
                        hideNavigation={true}
                        navigationClass={'categoriesNav'}
                        slidesPerView={{ mobile: 'auto', desk: 'auto' }}
                        spaceBetween={{ mobile: 5, desk: 10 }}
                    >
                        {
                            categories.map((category, i) =>
                                <div key={i}
                                    className={styles.item}
                                    onClick={() => { this.props.enableNavigation ? this.setActiveTab(category) : null }}>
                                    <span>
                                        <div>
                                            {category.name}
                                            <div className={classnames(
                                                styles.bar,
                                                i == 1 && !this.state.activeTab && !this.props.activeTab ||
                                                    this.state.activeTab === category.name ? styles.active : '')}>
                                            </div>
                                        </div>

                                    </span>
                                </div>
                            )
                        }
                    </Carousel>
                </div>
            </div>
        )
    };
};

const CategoriesTabs = _CategoriesTabs2;

export {
    CategoriesTabs
}